import React,{ useState, useEffect } from 'react';
import './Signup.css';
import axios from 'axios';
import { environment } from '../../environment';
import swal from 'sweetalert';

const Signup = () => {
  const signupurl = `https://gtt.onrender.com/auth/signup`;
  // const signupurl = `http://localhost:5005/auth/signup`;

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [warning, setWarning] = useState("");
  const [loading, setLoading] = useState(false);

  const registerUser =  (e) => { 
  e.preventDefault();
    if (!phone.startsWith('+')) {
      setWarning('Ju lutemi shkruani nje numer telefoni valid');
      swal({
        title: `Ju lutemi shkruani nje numer telefoni valid (+389 xxx xxx)`,
        buttons: {
          cancel: 'Mbyll',
        },
      })
      
    } else{

      setLoading(true);
     axios(signupurl, {
      method: 'POST',
      headers: {
              'Content-Type': 'application/json',
            },
      data: {
        username,email,password,phone
      }
    })
        .then(() => {
            setLoading(false);
            alert('You have been added to the system!');
        })
        .then(() => {
          window.location = '/';
        })
        .catch((error) => {
            console.error(error);
        });
    }

      }

  const handleUsername = (e) => {
    setUsername(e.target.value);
  }

  const handleEmail = (e) => {
    setEmail(e.target.value);
  }

  const handlePassword = (e) => {
    setPassword(e.target.value);
  }
  
  const handlePhone = (e) => {
    setPhone(e.target.value);
  }

  return (
    <>
 
    <div className='main-login container'>

      <form className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Regjistrohu</h3>
          
          <div className="form-group mt-3">
            <label>Emri dhe mbiemri</label>
            <input
              type="text"
              className="form-control mt-1"
              placeholder="Emri dhe mbiemri"
              name="username"
              onChange={handleUsername}
            />
          </div>
          
          <div className="form-group mt-3">
            <label>Email </label>
            <input
              type="text"
              className="form-control mt-1"
              placeholder="Enter email"
              name="email"
              onChange={handleEmail}

            />
          </div>

          <div className="form-group mt-3">
            <label>Phone </label>
            <input
              type="text"
              className="form-control mt-1"
              placeholder="Enter phone"
              name="phone"
              onChange={handlePhone}

            />
          </div>
          {/* {warning ? <p className="warning-text"> {warning} (+389 xxx xxx) </p> : ""} */}

          <div className="form-group mt-3">
            <label>Password</label>
            <input
              type="text"
              className="form-control mt-1"
              placeholder="Enter password"
              name="password"
              onChange={handlePassword}

            />
          </div>

          <div className="d-grid gap-2 mt-3">
            <button onClick={registerUser} className="button-black">
              Regjistrohu
              {loading === true ? <div class="spinner-border" style={{float: 'right'}} role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              :
              ""}
            </button>
          </div>

          <p className="forgot-password text-right mt-2">
            <a href="/auth/login">Jeni te regjistruar? Kliko ketu per tu identifikuar</a>
          </p>
        </div>
      </form>
    </div>
    </>
  )
}

export default Signup
